import Transition from './Transition';
import { TransitionName, TransitionProps } from './types';

interface Props extends TransitionProps {
    children: React.ReactNode;
}

export const FadeIn = (props: Props) => <Transition {...props} name={TransitionName.FadeIn} />;

export const FadeInDelayed = (props: Props) => <Transition {...props} name={TransitionName.FadeInDelayed} />;

export const SlideInFromLeft = (props: Props) => <Transition {...props} name={TransitionName.SlideInFromLeft} />;

export const SlideInFromRight = (props: Props) => <Transition {...props} name={TransitionName.SlideInFromRight} />;
